export default __webpack_public_path__ + "static/media/detail_mobile_15_3.1f9fa3e1.jpg";